<h2>Demande de contact</h2>
<main>
  <div #messageContainer class="test">
    <app-demande-contact-list
      [demandesContactList]="demandesContactList0()"
      [enCoursDeChargement]="enCoursDeChargement0()"
      [afficherPatient]="patient ? false : true"
    />
  </div>
  <form [formGroup]="demandeContactForm" (ngSubmit)="onSubmit()">
    <input type="text" formControlName="objet" placeholder="Objet" />
    <textarea
      type="text"
      formControlName="message"
      placeholder="Nouveau message (obligatoire)"
    ></textarea>
    <div>
      <input
        type="file"
        accept="application/pdf"
        value="@tui.link"
        value=""
        (change)="onFileSelected($event)"
      />
      <tui-icon icon="@tui.link" />
    </div>
    <button size="m">
      <tui-icon icon="@tui.send" />
    </button>
  </form>
</main>
